import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import axios from "axios";
import Cookies from 'universal-cookie';
import { toast } from 'react-toastify';
import { API_URL, STATUS_SUCCESS, STATUS_ERROR, AM_PM_FORMAT_WITH_DATE } from '../config/global_constants';
import moment from 'moment';
import axiosInstance from '../config/axios_interceptor.js';
import { confirmAlert } from 'react-confirm-alert';



// export async function callBackendAPI(request, source = {}, showError = true) {
//     let response = await axios.all(
//         request.map(params => {
//             const method = params.request_type || 'post'; // default to POST
//             const url = API_URL + params.method;

//             // Clone object excluding internal keys
//             const { request_type, method: endpoint, ...data } = params;

//             if (method.toLowerCase() === 'get') {
//                 return axiosInstance.get(url, { params: data });
//             } else {
//                 return axiosInstance.post(url, data);
//             }
//         })
//     );

//     let errorFlag = false;
//     let isLogout = false;
//     let errorRecord = [];
//     let apiResponse = response.map(el => {
//         let responseData = el.data;
//         if (responseData.status === STATUS_ERROR && !errorFlag && !responseData.is_logout) {
//             errorFlag = true;
//             errorRecord = (responseData.message) ? responseData.message : [];
//         }

//         if (responseData.is_logout) isLogout = true;
//         return responseData;
//     });

//     return { success: !errorFlag, data: apiResponse };
// }


export async function callBackendAPI(request, source = {}, showError = true) {
  try {
    const response = await axios.all(
      request.map(params => {
        const method = params.request_type || 'post';
        const url = API_URL + params.method;

        const { request_type, method: endpoint, ...data } = params;

        if (method.toLowerCase() === 'get') {
          return axiosInstance.get(url, { params: data });
        } else {
          return axiosInstance.post(url, data);
        }
      })
    );

    let errorFlag = false;
    let isLogout = false;
    let errorRecord = [];
    let apiResponse = response.map(el => {
      let responseData = el.data;

      if (responseData.status === STATUS_ERROR && !errorFlag && !responseData.is_logout) {
        errorFlag = true;
        errorRecord = responseData.message || [];
      }

      if (responseData.is_logout) isLogout = true;
      return responseData;
    });

    return { success: !errorFlag, data: apiResponse };

  } catch (err) {
    const errorResponse = err?.response?.data;
    const backendErrors = errorResponse?.errors || {};

    const errorObject = Object.keys(backendErrors).reduce((acc, key) => {
        const value = backendErrors[key];

        if (Array.isArray(value)) {
        acc[key] = value.length > 0 ? value[0] : "";
        } else if (typeof value === "string") {
        acc[key] = value;
        } else {
        acc[key] = "Invalid value";
        }

        return acc;
    }, {});

    return {
        success: false,
        errors: errorObject,
    };
    }
}


export async function handleFormInputs(e, field, state) {
    let fields = state;
    let oldValues = (fields[field] && fields[field].value) ? fields[field].value : "";
    fields[field] = {};

    let value = "";
    let inputType = "";

    if (e && e.target) {
        inputType = e.target.type;
        value = e.target.value;

        if (inputType === "password") value = value.trim();

        if (inputType === "select-multiple") {
            value = [];
            let options = e.target.options;
            for (let i = 0; i < options.length; i++) {
                if (options[i].selected && options[i].value) {
                    value.push(options[i].value);
                }
            }
        } else if (inputType === "file") {
            value = (e.target.files.length === 1) ? e.target.files[0] : e.target.files;
            fields[field]["file_count"] = e.target.files.length;
        }

        if (oldValues && inputType === "checkbox") {
            let coreVal = e.target.value;
            let currentVal = (e.target.checked) ? value : "";

            if (oldValues) {
                if (Array.isArray(oldValues) && oldValues.length > 0) {
                    if (!currentVal && oldValues.includes(coreVal)) {
                        oldValues.splice(oldValues.indexOf(coreVal), 1);
                        currentVal = (oldValues.length === 1) ? oldValues[0] : oldValues;
                    } else if (currentVal) {
                        oldValues.push(currentVal);
                        currentVal = oldValues;
                    }
                } else if (typeof oldValues === "string") {
                    if (currentVal) {
                        let tmpArray = [oldValues, currentVal];
                        currentVal = tmpArray;
                    }
                }
            }

            fields[field]["value"] = currentVal;
        } else {
            fields[field]["value"] = (inputType === "checkbox") ? ((e.target.checked) ? value : "") : value;
        }

        fields[field]["type"] = inputType;

    } else {
        // For direct value (like DatePicker)
        fields[field]["value"] = e;
        fields[field]["type"] = "custom";
    }

    return fields;
}



export async function handleFormValidation(validations, state, params, sendToAPI = true, showSuccessFlash = true, stopErrorScroll) {
    let fields = state;
    let errors = [];
    let formIsValid = true;
    /** Validate form data */
    if (validations.constructor === Object && Object.keys(validations).length > 0) {
        Object.keys(validations).forEach(field => {
            var value = (fields[field] && typeof fields[field].value !== typeof undefined) ? fields[field].value : "";
            var validatorRules = validations[field].rules;
            var fieldLabel = validations[field].label.toLowerCase();
            var targetLabel = validations[field].target_label ? validations[field].target_label.toLowerCase() : "";
            var targetFieldValue = (field === "confirm_password" && fields.password && fields.password.value) ? fields.password.value : "";
            var msg = validator(fieldLabel, validatorRules, value, targetFieldValue, targetLabel);
            if (msg) {
                formIsValid = false;
                errors.push({ param: field, msg: msg });
            }
        });
    }

    /** Send error response **/
    if (!formIsValid) {
        if (!stopErrorScroll) scrollToErrorDiv();
        return { "success": false, "errors": reFormatErrors(errors) };
    }

    /** Send succcess response **/
    if (!sendToAPI) return { "success": true };
    //put formIsValid in param of if for running below code
    // if (formIsValid) {
    //     let result = await callBackendAPI(params, false, false);
    //     console.log("result-----",result)
    //     if (result.data[0].status === STATUS_SUCCESS) {

    //         /** Send success response **/
    //         return { "success": true, "msg": (showSuccessFlash) ? reFormatSuccess(result.data[0].message) : "", "data": result.data[0] };
    //     } else {
    //         if (!stopErrorScroll) scrollToErrorDiv();
    //         /** Send error response **/
    //         return { "success": false, "errors": reFormatErrors(result.data[0].message) };
    //     }
    // }

    if (formIsValid) {
        let result = await callBackendAPI(params, false, false);

        const dataArray = result?.data;
        const firstItem = Array.isArray(dataArray) && dataArray.length > 0 ? dataArray[0] : null;

        if (firstItem && firstItem.status === STATUS_SUCCESS) {
            /** Send success response **/
            return {
                success: true,
                msg: showSuccessFlash ? reFormatSuccess(firstItem.message) : "",
                data: firstItem
            };
        } else {
            if (!stopErrorScroll) scrollToErrorDiv();
            /** Send error response **/
            const backendErrors = firstItem?.errors || result?.errors || {};
            return {
                success: false,
                errors: backendErrors
            };
        }
    }

}



function validator(field, rules, value, targetFieldValue, targetLabel) {
    /** Basic validation message **/
    var messages = {
        require: "Please enter {field}.",
        select: "Please select {field}.",
        // terms		:	translate("basic_validation.please_accept_field"),
        // valid_location:	translate("basic_validation.please_select_valid_field"),
        integer: "{field} must be number.",
        // year		:	translate("basic_validation.field_must_be_formatted_as_a_year"),
        decimal: "{field} must be numeric or more than one.",
        date: "{field} must be formatted as a date.",
        email: "Please enter valid email.",
        // url			:	translate("basic_validation.field_must_be_formatted_as_url"),
        number: "{field} should be numeric.",
        // tooLong		:	translate("basic_validation.field_cannot_be_longer_than_max_characters"),
        // tooShort	:	translate("basic_validation.field_length_should_be_digits_long"),
        // equal		:	translate("basic_validation.field_should_be_same_as_target_field"),
        email_mobile: "Please enter valid email mobile number.",
        mobile_number: "Please enter valid {field}.",
        otp: "Please enter valid otp",
        // iframe      :	translate("basic_validation.please_enter_valid_iframe"),
        alphabet: "{field} must be alphabet.",
    };

    /** Basic validation regex **/
    var patterns = {
        year: /^\d{4}$/,
        integer: /^[0-9]+$/,
        alphabet: /^[a-zA-Z ]+$/,
        decimal: /^[1-9]\d*(\.\d+)?$/,
        // email_mobile:	/\^\(\[a-zA-Z0-9_\\\.\\-\]\)\+\\@\(\(\[a-zA-Z0-9\\-\]\)\+\\\.\)\+\(\[a-zA-Z0-9\]\{2,4\}\)\|\(\[0-9\]\{10\}\)\+\$/,
        // email		:	/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
        email: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,12})+$/,
        url: /\^\(\(\[\^<>\(\)\\\[\\\]\\\.,;:\\s@\\"\]\+\(\\\.\[\^<>\(\)\\\[\\\]\\\.,;:\\s@\\"\]\+\)\*\)\|\(\\"\.\+\\"\)\)@\(\(\[\^<>\(\)\[\\\]\\\.,;:\\s@\\"\]\+\\\.\)\+\[\^<>\(\)\[\\\]\\\.,;:\\s@\\"\]\{2,\}\)\$/i,
        // url			:	/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/,
        mobile_number: /^([0-9]{10})+$/,
        iframe: /(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/g,
    };

    var msg = "";
    if (!value || value.constructor === String) {
        value = (value) ? value.trim() : "";
        for (var i = 0; i < rules.length; i++) {
            var validationMethod = rules[i];
            switch (validationMethod) {
                case "required":
                    if (!value) msg = messages.require;
                    break;
                case "select":
                    if (!value) msg = messages.select;
                    break;
                case "valid_location":
                    if (!value) msg = messages.valid_location;
                    break;
                case "email":
                    if (!patterns.email.test(value)) msg = messages.email;
                    break;
                case "email_mobile":
                    if (!patterns.email_mobile.test(value)) msg = messages.email_mobile;
                    break;
                case "alphabet":
                    if (!patterns.alphabet.test(value)) msg = messages.alphabet;
                    break;
                case "mobile_number":
                    if (!patterns.mobile_number.test(value)) msg = messages.mobile_number;
                    break;
                case "minLength":
                    if (value.length < 8 || value.length > 16) msg = messages.tooShort;
                    break;
                case "equal":
                    field = field.charAt(0).toUpperCase() + field.slice(1);
                    if (value !== targetFieldValue) msg = messages.equal.replace(/{target_field}/, (targetLabel ? targetLabel : "password"));
                    break;
                case "integer":
                    if (!patterns.integer.test(value)) msg = messages.integer;
                    break;
                case "decimal":
                    if (!patterns.decimal.test(value)) msg = messages.decimal;
                    break;
                case "year":
                    if (!patterns.year.test(value)) msg = messages.year;
                    break;
                case "otp":
                    if (value.length < 4) msg = messages.otp;
                    break;
                case "terms":
                    if (!value) msg = messages.terms;
                    break;
                case "url":
                    if (!patterns.url.test(value)) msg = messages.url;
                    break;
                case "iframe":
                    if (!patterns.iframe.test(value)) msg = messages.iframe;
                    break;
                default:
                    break;
            }
            if (msg) break;
        };
    };
    field = (field.replace(/_/g, " "));
    return ucfirst(msg.replace(/{field}/, field));
    // return ucfirst(translate(msg.replace(/{field}/,field)));
}// end validator();

export function reFormatErrors(errorArray) {
    var errorObj = {};
    if (errorArray && errorArray.constructor === Array && errorArray.length > 0) {
        errorArray.forEach(records => {
            if (records.param && records.msg) {
                if (records.param === "invalid-access") {
                    notice('error', records.msg);
                } else if (records.param === STATUS_ERROR) {
                    notice('error', records.msg);
                } else {
                    errorObj[records.param] = records.msg;
                }
            }
        });
    } else if (errorArray && errorArray.constructor === String) {
        notice('error', errorArray);
    }
    return errorObj;
}// end reFormatErrors();

export function reFormatSuccess(successArray) {
    var successObj = {};
    if (successArray && successArray.constructor === Array && successArray.length > 0) {
        successArray.forEach(records => {
            if (records.param && records.msg) {
                if (records.param === STATUS_SUCCESS && records.msg !== STATUS_SUCCESS) {
                    notice('success', records.msg);
                } else {
                    successObj[records.param] = records.msg;
                }
            }
        });
    } else if (successArray && successArray.constructor === String) {
        notice('success', successArray);
    }
    return successObj;
}// end reFormatSuccess();


export async function notice(type, message, timeout, displayPosition, showHideTransition) {
    displayPosition = (displayPosition === "undefined") ? displayPosition : (toast.POSITION?.TOP_RIGHT || "top-right");
    showHideTransition = (showHideTransition === "undefined") ? showHideTransition : "fade";
    timeout = (timeout === "undefined") ? timeout : 10000;

    toast.dismiss();
    if (message !== "" && message !== undefined) {
        if (type === 'success' || type === STATUS_SUCCESS) toast.success(message, { position: displayPosition });
        if (type === 'error' || type === STATUS_ERROR) toast.error(message, { position: displayPosition });
    }
}// end notice()


/**
 * For scroll to first error div
 *
 *@param null
*
* @return null
*/
export function scrollToErrorDiv() {
    setTimeout(function () {
        let errorDiv = document.getElementsByClassName("error");
        let isHave = false;
        for (var i = 0; i < errorDiv.length; i++) {
            if (!isHave && document.getElementsByClassName("error")[i].innerHTML) {
                isHave = true;
                let hei = document.getElementsByClassName("error")[i].getBoundingClientRect().top + window.scrollY - 80;
                window.scroll({ top: hei, behavior: 'smooth' });
            }
        }
    }, 100)
    return;
}// end scrollToErrorDiv();

export function ucfirst(s) {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1);
}// end ucfirst()

/* format the date in required format */
export function formatDate(dateToBeFormat, format = AM_PM_FORMAT_WITH_DATE) {
    return moment(dateToBeFormat).format(format);
};

/** For confirm box */
export function customConfirmBox(message, title) {
    return new Promise((resolve) => {
        if (!title) title = "Are you sure";
        confirmAlert({
            title: "",
            message: title + ", " + String(message).toLowerCase(),
            buttons: [
                {
                    label: "Yes",
                    className: "btn-alert w-25 d-inline",
                    onClick: () => { resolve(true) }
                },
                {
                    label: "No",
                    className: "btn-alert w-25 d-inline",
                    onClick: () => { resolve(false) }
                }
            ]
        });
    });
}// end customConfirmBox()


/** Logout account **/
export async function logout(isShowMsg) {
    let adminDetails = JSON.parse(localStorage.getItem("admin_details") || "{}");
    let userId = adminDetails._id || "";

    /** Remove localStorage items */
    localStorage.removeItem("admin_details");
    localStorage.removeItem("token");
    localStorage.removeItem("auth_roles");

    /** Redirect to login */
    setTimeout(() => {
        window.location.href = '/login';
    }, 500);


    return;
}// end logout()


/**
 * user name initial string
 */
export function showUserSortName(userName = ""){
	if(!userName || userName === "" || userName.constructor !== String) return "";

	let nameArray 	    =	userName.trim().split(" ");
	let firstInitial    =	nameArray[0].charAt(0).toUpperCase();
	let lastInitial	    =	nameArray.length > 1 && nameArray[nameArray.length-1].charAt(0).toUpperCase() || "";

	return firstInitial + lastInitial;
}// end showUserSortName()

